<div class="mb-2">
  <h1 class="main-title">Gestión de turnos > Turnos históricos</h1>
</div>

<div class="single-page-content !pt-12">
  <div class="flex justify-between items-center mb-4 gap-4 filter-container">
    <!-- Filtro por tipo - esquina superior izquierda -->

    <div class="mb-3">
      <label class="block text-sm font-bold mb-2">Tipos de turno</label>
      <select class="select" [formControl]="typeFilter">
        <option value="all">Todos</option>
        <option *ngFor="let type of availableTypes" [value]="type">{{ type }}</option>
      </select>
    </div>

    <!-- Filtro por fecha y botón limpiar - esquina superior derecha -->
    
    <div class="flex items-center gap-2">
      <div class="relative inline-block">
        <button class="button button-outlined-primary" (click)="picker.open()" >
          <i class="fa-solid fa-calendar-days"></i>
          Fecha
        </button>
        
        <!-- Input oculto para el datepicker posicionado cerca del botón -->
        <mat-form-field class="absolute opacity-0 pointer-events-none w-0 h-0 overflow-hidden">
          <input matInput [matDatepicker]="picker" [formControl]="dateFilter" [max]="maxDate">
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      
      <button 
        *ngIf="typeFilter.value !== 'all' || dateFilter.value"
        (click)="clearFilters()"
        class="clear-filters-btn text-gray-600 border border-gray-400 hover:bg-gray-50"
        title="Limpiar filtros">
        Limpiar
      </button>
    </div>
  </div>

  <app-table 
    class="table-news table-switch" 
    [columns]="tableColumns" 
    [data]="filteredShiftClosures"
    [pageSizeOptions]="[20, 50, 100]"
    [initialPageSize]="20">
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button 
          *ngIf="visation.hora_fin !== 'Sin fecha' && !visation.isReportAvailable"
          (click)="navigateToDetail(visation.id, visation.tipo, visation.codigo_tipo)"
          title="Generar Informe"
          class="button button-sm text-red-600 border border-red-600 hover:bg-red-50"
          style="font-size: 8px; padding: 2px 6px;">
          Generar informe
        </button>
        <button 
          *ngIf="visation.hora_fin !== 'Sin fecha' && visation.isReportAvailable"
          (click)="navigateToDetail(visation.id, visation.tipo, visation.codigo_tipo)" 
          title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="">
        </button>
        <button 
          *ngIf="visation.hora_fin !== 'Sin fecha' && visation.isReportAvailable" 
  (click)="exportPdf(visation.id)" 
          title="Exportar pdf"
        >
          <img src="assets/icons/doc-icon.svg" alt="" style="width:10px">
        </button>
      </div>
    </ng-template>
  </app-table>
</div>
